import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { DynamicModalContext } from '../../../init/dynamicModals';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, Checkbox } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceAccount = (props) => {

    const { journalVoucher, setJournalVoucher, setInvoices} = props;

    const { api, userData, settingData, auxAccountData, selectedYear, branchData, projectData, formLanguages } = useContext(DataContext);
    const { openAddAccountModal } = useContext(DynamicModalContext);

    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const minDate = `${selectedYear?.label}-01-01`;
    const maxDate = `${selectedYear?.label}-12-31`;

    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);




    // Account Options
    const accountOptions = auxAccountData?.map(item => ({
        value: item.id,
        label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english +
         (item.phone? ' [' + item.phone + ']' : ''),
        invoices: item.journalVouchers,
    }));
    const loadAccountOptions = (inputValue, callback) => {
        const filteredOptions = inputValue ? accountOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
        callback(filteredOptions);
    };
   
    // Branch Options
    const branchOptions = branchData?.map(item => ({
        value: item.id,
        label: item.name,
    }));

    // Project Options
    const projectOptions = projectData?.map(item => ({
        value: item.id,
        label: item.name,
    }))

    // Generic handler for input changes
    const handleInputChange = (e, type) => {
        let { name, value } = e.target;
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: value,
        }));
    };




    // handle select change
    const handleSelectChange = (selectedOption, name) => {
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: selectedOption?.value,
        }));

        if (name == 'accountId') {
            const typesArray = [formLanguages.formLanguages, formLanguages.ExpenseInvoice, formLanguages.salary];
            const salesInvoices = selectedOption?.invoices?.filter(i => typesArray.includes(i.type) && i.paymentType == 'onAccount');
            setInvoices(salesInvoices)
        }
    };


    const onCheckChange = (e) => {
        const name = e.target.name;
        const checked = e.target.checked;
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };


    return (


        <div>

            <Row className="mb-3">

                {/* Account */}
                <Col>
                    <Form.Label>{formLanguages.Account}<span style={{ color: 'red' }}>*</span> </Form.Label>
                    <FaPlus onClick={() => openAddAccountModal()} style={{ marginLeft: '20px', marginBottom: '3px', cursor: 'pointer' }} />
                    <AsyncSelect
                        isClearable={true}
                        cacheOptions
                        loadOptions={loadAccountOptions}
                        defaultOptions={[]}
                        onChange={(e) => handleSelectChange(e, 'accountId')}
                        value={accountOptions?.find(option => option.value === journalVoucher.accountId)}
                        noOptionsMessage={() => 'type to view'}
                        required
                    />
                </Col>

                {/* Date */}
                <Col>
                    <Form.Label>{formLanguages.Date}<span style={{ color: 'red' }}>*</span></Form.Label>

                    <Form.Control size="sm" type="date" name='date'
                        min={minDate} max={maxDate}
                        value={journalVoucher.date}
                        onChange={(e) => handleInputChange(e, 'text')}
                    />
                </Col>

            </Row>


            <Row className="mb-3">
                <Col>
                    <Form.Label>{formLanguages.Project}</Form.Label>
                    <Select
                        options={projectOptions}
                        isClearable={true}
                        isSearchable={true}
                        placeholder="Select"
                        onChange={(e) => handleSelectChange(e, 'projectId')}
                        value={projectOptions?.find(option => option.value === journalVoucher.projectId) || []}
                    />
                </Col>


                <Col>
                    <Form.Label>{formLanguages.Branch}</Form.Label>
                    <Select
                        options={branchOptions}
                        isClearable={true}
                        isSearchable={true}
                        placeholder="Select"
                        onChange={(e) => handleSelectChange(e, 'branchId')}
                        value={branchOptions?.find(option => option.value === journalVoucher.branchId) || []}
                    />
                </Col>
            </Row>



            <Row className="mb-3">

                {/* Reference */}
                <Col>
                    <Form.Label>{formLanguages.Reference}#</Form.Label>
                    <Form.Control type="text" name="refNumber"
                        onChange={(e) => handleInputChange(e, 'text')}
                        value={journalVoucher.refNumber} />
                </Col>

                {/* Invoice */}
                <Col>
                    <Row className="mb-4" style={{ marginTop: '12px' }}>
                    </Row>
                    <Checkbox onChange={onCheckChange} checked={journalVoucher.onInvoice} name="onInvoice">
                        {formLanguages.ApplyPaymentToInvoice}
                    </Checkbox>
                </Col>

            </Row>



        </div>


    )
}


export default InvoiceAccount;